import "core-js/modules/es.array.map";
import React from 'react';
import AccessibleClick from '../../accessible-click/AccessibleClick';
import Block from '../../block/Block';

var AccordionControl = function AccordionControl(_ref) {
  var children = _ref.children,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      toggle = _ref.toggle,
      parentId = _ref.parentId,
      childId = _ref.childId,
      _ref$headingLevel = _ref.headingLevel,
      headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel,
      elementRef = _ref.elementRef,
      _ref$el = _ref.el,
      el = _ref$el === void 0 ? 'div' : _ref$el;
  var Element = el;
  var clone = React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      open: open
    });
  });
  return /*#__PURE__*/React.createElement(Block, {
    role: "heading",
    "aria-level": headingLevel
  }, /*#__PURE__*/React.createElement(AccessibleClick, {
    spaceKey: true,
    ref: elementRef
  }, /*#__PURE__*/React.createElement(Element, {
    id: parentId,
    tabIndex: 0,
    open: open,
    role: "button",
    "aria-controls": open ? childId : '',
    "aria-expanded": open,
    onAccessibleClick: toggle
  }, clone)));
};

export default AccordionControl;